import React, { createContext, useContext, useState, useEffect } from "react";

export const translations = {
  de: {
    nav: {
      home: "Start",
      about: "Über uns",
      dishes: "Spezialitäten",
      gallery: "Galerie",
      menu: "Speisekarte",
      hours: "Öffnungszeiten",
      reviews: "Bewertungen",
      contact: "Kontakt",
      events: "Veranstaltungen",
      vouchers: "Gutscheine",
      reserve: "Tisch reservieren",
    },
    hero: {
      eyebrow: "Pizzeria Quattro Stelle · Krumbach",
      title: "Authentische italienische Küche in Krumbach",
      subtitle:
        "Traditionelle Rezepte, frische Zutaten und echte italienische Gastfreundschaft.",
      reserve: "Tisch reservieren",
      menu: "Speisekarte ansehen",
    },
    about: {
      eyebrow: "Unsere Geschichte",
      title: "Ein Stück Italien im Herzen Schwabens",
      p1: "Die Pizzeria Quattro Stelle ist ein familiengeführtes Restaurant, in dem die Liebe zur italienischen Küche von Generation zu Generation weitergegeben wird. Bei uns verbinden sich traditionelle Rezepte mit der Wärme echter italienischer Gastfreundschaft.",
      p2: "Wir verwenden ausschließlich frische, sorgfältig ausgewählte Zutaten – von San-Marzano-Tomaten über handgemachte Pasta bis hin zu frisch zubereiteten Saucen. Jedes Gericht erzählt eine Geschichte von Qualität, Authentizität und Leidenschaft.",
      stat1: "Jahre Erfahrung",
      stat2: "Hausgemachte Gerichte",
      stat3: "Frische Zutaten täglich",
      values: [
        { t: "Frische Zutaten", d: "Täglich frisch, regional und aus Italien importiert." },
        { t: "Traditionelle Rezepte", d: "Authentische Familienrezepte aus Generationen." },
        { t: "Echte Gastfreundschaft", d: "Eine herzliche Atmosphäre wie in Italien." },
      ],
    },
    dishes: {
      eyebrow: "Unsere Spezialitäten",
      title: "Mit Liebe zubereitet",
      subtitle:
        "Entdecken Sie unsere handverlesenen Spezialitäten – jede ein Meisterwerk italienischer Handwerkskunst.",
      cta: "Komplette Speisekarte ansehen",
      items: [
        { name: "Pizza", desc: "Knusprig gebacken mit San-Marzano-Tomaten und feinstem Mozzarella." },
        { name: "Frische Pasta", desc: "Täglich hausgemacht nach original italienischen Rezepten." },
        { name: "Italienische Vorspeisen", desc: "Klassische Antipasti mit erlesenen Spezialitäten." },
        { name: "Salate", desc: "Frische, knackige Salate mit feinsten Zutaten." },
        { name: "Hausgemachte Desserts", desc: "Süße Verführungen wie Tiramisù und Panna Cotta." },
      ],
    },
    gallery: {
      eyebrow: "Galerie",
      title: "Eindrücke aus unserem Restaurant",
      subtitle: "Ein Blick auf das, was Sie bei uns erwartet.",
    },
    hours: {
      eyebrow: "Öffnungszeiten",
      title: "Wann Sie uns besuchen können",
      note: "Wir freuen uns auf Ihren Besuch. Für Reservierungen rufen Sie uns gerne an oder nutzen Sie unser Formular.",
      closed: "Geschlossen",
      lunch: "Mittag",
      dinner: "Abend",
      days: {
        mon: "Montag",
        tue: "Dienstag",
        wed: "Mittwoch",
        thu: "Donnerstag",
        fri: "Freitag",
        sat: "Samstag",
        sun: "Sonntag",
      },
      today: "Heute",
    },
    reviews: {
      eyebrow: "Bewertungen",
      title: "Was unsere Gäste sagen",
      subtitle: "Echte Bewertungen unserer Gäste bei Google.",
    },
    contact: {
      eyebrow: "Kontakt & Reservierung",
      title: "Reservieren Sie Ihren Tisch",
      subtitle:
        "Wir freuen uns darauf, Sie verwöhnen zu dürfen. Buchen Sie jetzt Ihren Tisch.",
      call: "Anrufen",
      email: "E-Mail",
      whatsapp: "WhatsApp",
      directions: "Route planen",
      address: "Adresse",
      phone: "Telefon",
      form: {
        title: "Tischreservierung",
        name: "Name",
        namePh: "Ihr vollständiger Name",
        emailPh: "ihre@email.de",
        phone: "Telefonnummer",
        phonePh: "Ihre Telefonnummer",
        date: "Datum",
        time: "Uhrzeit",
        guests: "Personen",
        message: "Nachricht (optional)",
        messagePh: "Besondere Wünsche oder Anmerkungen",
        submit: "Reservierung anfragen",
        submitting: "Wird gesendet...",
        success: "Vielen Dank! Ihre Reservierungsanfrage wurde gesendet. Wir melden uns in Kürze.",
        error: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
      },
    },
    footer: {
      tagline: "Authentische italienische Küche im Herzen von Krumbach.",
      quickLinks: "Navigation",
      contact: "Kontakt",
      hours: "Öffnungszeiten",
      follow: "Folgen Sie uns",
      rights: "Alle Rechte vorbehalten.",
      impressum: "Impressum",
      datenschutz: "Datenschutz",
    },
    menuPage: {
      eyebrow: "Speisekarte",
      title: "Unsere Speisekarte",
      subtitle: "Authentische italienische Gerichte, mit Leidenschaft zubereitet.",
      back: "Zurück zur Startseite",
      reserve: "Tisch reservieren",
    },
    events: {
      eyebrow: "Feiern & Veranstaltungen",
      title: "Feiern Sie bei uns",
      subtitle: "Ob Geburtstag, Familienfeier oder Firmenevent – wir machen Ihre Feier zu einem besonderen italienischen Erlebnis.",
      intro: "Genießen Sie Ihre Feier in gemütlicher Atmosphäre bei authentisch italienischer Küche. Wir stellen gerne ein individuelles Menü für Sie zusammen und kümmern uns um alle Details, damit Sie einen unvergesslichen Abend erleben.",
      typesTitle: "Anlässe",
      types: [
        { t: "Geburtstage", d: "Feiern Sie Ihren Ehrentag mit Familie und Freunden." },
        { t: "Familienfeiern", d: "Taufe, Kommunion, Jubiläen – wir sind für Sie da." },
        { t: "Firmenfeiern", d: "Teamevents und Feiern in stilvollem Ambiente." },
        { t: "Besondere Anlässe", d: "Erzählen Sie uns von Ihrer Idee – wir setzen sie um." },
      ],
      formTitle: "Anfrage senden",
      back: "Zurück zur Startseite",
      form: {
        name: "Name",
        namePh: "Ihr vollständiger Name",
        emailPh: "ihre@email.de",
        phone: "Telefonnummer",
        phonePh: "Ihre Telefonnummer",
        occasion: "Anlass",
        date: "Wunschdatum",
        guests: "Anzahl Gäste",
        message: "Ihre Nachricht",
        messagePh: "Beschreiben Sie Ihre Feier, Wünsche oder Fragen …",
        submit: "Anfrage senden",
        submitting: "Wird gesendet...",
        success: "Vielen Dank! Ihre Veranstaltungsanfrage wurde gesendet. Wir melden uns in Kürze.",
        error: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
      },
      occasions: ["Geburtstag", "Familienfeier", "Firmenfeier", "Taufe / Kommunion", "Sonstiges"],
    },
    vouchers: {
      eyebrow: "Geschenkidee",
      title: "Digitale Gutscheine",
      subtitle: "Verschenken Sie italienischen Genuss \u2013 in wenigen Klicks, sofort per E-Mail.",
      chooseDesign: "Design w\u00e4hlen",
      chooseAmount: "Betrag w\u00e4hlen",
      custom: "Wunschbetrag",
      customPh: "z. B. 150",
      customHint: "F\u00fcr Betr\u00e4ge \u00fcber 100 \u20ac einfach hier den Wunschbetrag eingeben.",
      yourDetails: "Ihre Angaben",
      buyerName: "Ihr Name",
      buyerEmail: "Ihre E-Mail",
      recipient: "Name des Beschenkten (optional)",
      message: "Pers\u00f6nliche Nachricht (optional)",
      messagePh: "z. B. Alles Gute zum Geburtstag!",
      pay: "Jetzt kaufen",
      paying: "Weiterleitung \u2026",
      securePay: "Sichere Bezahlung \u00fcber Stripe",
      back: "Zur\u00fcck zur Startseite",
      errorAmount: "Bitte einen g\u00fcltigen Betrag zwischen 10 und 2000 \u20ac w\u00e4hlen.",
      errorGeneric: "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
      designDesc: { classic: "Zeitlos & warm", festive: "Festlich & lebendig", elegant: "Edel & schlicht" },
      success: {
        title: "Vielen Dank!",
        subtitle: "Ihr Gutschein wurde erfolgreich gekauft.",
        codeLabel: "Ihr Gutschein-Code",
        emailNote: "Wir haben Ihnen den Gutschein als PDF per E-Mail gesendet.",
        checking: "Zahlung wird best\u00e4tigt \u2026",
        failedTitle: "Zahlung nicht abgeschlossen",
        failedNote: "Die Zahlung wurde nicht abgeschlossen. Bitte versuchen Sie es erneut.",
        home: "Zur Startseite",
        retry: "Erneut versuchen",
      },
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      dishes: "Specialties",
      gallery: "Gallery",
      menu: "Menu",
      hours: "Opening Hours",
      reviews: "Reviews",
      contact: "Contact",
      events: "Events",
      vouchers: "Vouchers",
      reserve: "Reserve a table",
    },
    hero: {
      eyebrow: "Pizzeria Quattro Stelle · Krumbach",
      title: "Authentic Italian Cuisine in Krumbach",
      subtitle:
        "Traditional recipes, fresh ingredients and genuine Italian hospitality.",
      reserve: "Reserve a table",
      menu: "View the menu",
    },
    about: {
      eyebrow: "Our Story",
      title: "A Piece of Italy in the Heart of Swabia",
      p1: "Pizzeria Quattro Stelle is a family-run restaurant where the love for Italian cuisine is passed down from generation to generation. We combine traditional recipes with the warmth of genuine Italian hospitality.",
      p2: "We use only fresh, carefully selected ingredients – from San Marzano tomatoes to handmade pasta and freshly prepared sauces. Every dish tells a story of quality, authenticity and passion.",
      stat1: "Years of Experience",
      stat2: "Homemade Dishes",
      stat3: "Fresh Ingredients Daily",
      values: [
        { t: "Fresh Ingredients", d: "Fresh daily, regional and imported from Italy." },
        { t: "Traditional Recipes", d: "Authentic family recipes across generations." },
        { t: "Genuine Hospitality", d: "A warm atmosphere just like in Italy." },
      ],
    },
    dishes: {
      eyebrow: "Our Specialties",
      title: "Prepared with Love",
      subtitle:
        "Discover our handpicked specialties – each a masterpiece of Italian craftsmanship.",
      cta: "View the full menu",
      items: [
        { name: "Pizza", desc: "Crispy baked with San Marzano tomatoes and finest mozzarella." },
        { name: "Fresh Pasta", desc: "Made fresh daily following original Italian recipes." },
        { name: "Italian Starters", desc: "Classic antipasti with exquisite specialties." },
        { name: "Salads", desc: "Fresh, crisp salads with the finest ingredients." },
        { name: "Homemade Desserts", desc: "Sweet temptations like tiramisù and panna cotta." },
      ],
    },
    gallery: {
      eyebrow: "Gallery",
      title: "Impressions from Our Restaurant",
      subtitle: "A glimpse of what awaits you.",
    },
    hours: {
      eyebrow: "Opening Hours",
      title: "When You Can Visit Us",
      note: "We look forward to your visit. For reservations, please call us or use our form.",
      closed: "Closed",
      lunch: "Lunch",
      dinner: "Dinner",
      days: {
        mon: "Monday",
        tue: "Tuesday",
        wed: "Wednesday",
        thu: "Thursday",
        fri: "Friday",
        sat: "Saturday",
        sun: "Sunday",
      },
      today: "Today",
    },
    reviews: {
      eyebrow: "Reviews",
      title: "What Our Guests Say",
      subtitle: "Real reviews from our guests on Google.",
    },
    contact: {
      eyebrow: "Contact & Reservation",
      title: "Reserve Your Table",
      subtitle: "We look forward to spoiling you. Book your table now.",
      call: "Call",
      email: "Email",
      whatsapp: "WhatsApp",
      directions: "Get directions",
      address: "Address",
      phone: "Phone",
      form: {
        title: "Table Reservation",
        name: "Name",
        namePh: "Your full name",
        emailPh: "your@email.com",
        phone: "Phone number",
        phonePh: "Your phone number",
        date: "Date",
        time: "Time",
        guests: "Guests",
        message: "Message (optional)",
        messagePh: "Special requests or notes",
        submit: "Request reservation",
        submitting: "Sending...",
        success: "Thank you! Your reservation request has been sent. We will get back to you shortly.",
        error: "Something went wrong. Please try again.",
      },
    },
    footer: {
      tagline: "Authentic Italian cuisine in the heart of Krumbach.",
      quickLinks: "Navigation",
      contact: "Contact",
      hours: "Opening Hours",
      follow: "Follow us",
      rights: "All rights reserved.",
      impressum: "Imprint",
      datenschutz: "Privacy",
    },
    menuPage: {
      eyebrow: "Menu",
      title: "Our Menu",
      subtitle: "Authentic Italian dishes, prepared with passion.",
      back: "Back to home",
      reserve: "Reserve a table",
    },
    events: {
      eyebrow: "Celebrations & Events",
      title: "Celebrate with Us",
      subtitle: "Birthday, family gathering or company event – we turn your celebration into a special Italian experience.",
      intro: "Enjoy your celebration in a cosy atmosphere with authentic Italian cuisine. We are happy to put together an individual menu for you and take care of every detail so you can enjoy an unforgettable evening.",
      typesTitle: "Occasions",
      types: [
        { t: "Birthdays", d: "Celebrate your special day with family and friends." },
        { t: "Family Gatherings", d: "Baptism, communion, anniversaries – we are here for you." },
        { t: "Company Events", d: "Team events and celebrations in a stylish setting." },
        { t: "Special Occasions", d: "Tell us your idea – we will make it happen." },
      ],
      formTitle: "Send Inquiry",
      back: "Back to home",
      form: {
        name: "Name",
        namePh: "Your full name",
        emailPh: "your@email.com",
        phone: "Phone number",
        phonePh: "Your phone number",
        occasion: "Occasion",
        date: "Preferred date",
        guests: "Number of guests",
        message: "Your message",
        messagePh: "Describe your celebration, wishes or questions …",
        submit: "Send inquiry",
        submitting: "Sending...",
        success: "Thank you! Your event inquiry has been sent. We will get back to you shortly.",
        error: "Something went wrong. Please try again.",
      },
      occasions: ["Birthday", "Family gathering", "Company event", "Baptism / Communion", "Other"],
    },
    vouchers: {
      eyebrow: "Gift Idea",
      title: "Digital Vouchers",
      subtitle: "Give the gift of Italian indulgence \u2013 in a few clicks, delivered instantly by email.",
      chooseDesign: "Choose a design",
      chooseAmount: "Choose an amount",
      custom: "Custom amount",
      customPh: "e.g. 150",
      customHint: "For amounts above \u20ac100, simply enter your custom amount here.",
      yourDetails: "Your details",
      buyerName: "Your name",
      buyerEmail: "Your email",
      recipient: "Recipient's name (optional)",
      message: "Personal message (optional)",
      messagePh: "e.g. Happy birthday!",
      pay: "Buy now",
      paying: "Redirecting \u2026",
      securePay: "Secure payment via Stripe",
      back: "Back to home",
      errorAmount: "Please choose a valid amount between \u20ac10 and \u20ac2000.",
      errorGeneric: "Something went wrong. Please try again.",
      designDesc: { classic: "Timeless & warm", festive: "Festive & vibrant", elegant: "Refined & minimal" },
      success: {
        title: "Thank you!",
        subtitle: "Your voucher has been purchased successfully.",
        codeLabel: "Your voucher code",
        emailNote: "We have sent the voucher to you as a PDF by email.",
        checking: "Confirming payment \u2026",
        failedTitle: "Payment not completed",
        failedNote: "The payment was not completed. Please try again.",
        home: "Back to home",
        retry: "Try again",
      },
    },
  },
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("qs_lang") || "de");

  useEffect(() => {
    localStorage.setItem("qs_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = translations[lang];
  const toggle = () => setLang((p) => (p === "de" ? "en" : "de"));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
